var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008559(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9132 75.8184L82.9133 75.8185C83.9742 76.86 84.4225 78.028 84.371 79.1674C84.3192 80.315 83.7562 81.5143 82.6408 82.5925C81.4426 83.7505 80.1368 84.3274 78.8636 84.3722C77.5936 84.4168 76.2822 83.9348 75.0613 82.8376C69.9987 78.2881 65.0476 73.6304 60.1702 69.042C58.4104 67.3864 56.6601 65.7398 54.9176 64.1106L62.7535 56.8536C64.442 58.4301 66.166 60.0273 67.9114 61.6442C72.8467 66.2166 77.9532 70.9474 82.9132 75.8184Z",
    fill: "#F7B53C",
    stroke: "black",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 65C50.6731 65 65 50.6731 65 33C65 15.3269 50.6731 1 33 1C15.3269 1 1 15.3269 1 33C1 50.6731 15.3269 65 33 65Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 52C43.4934 52 52 43.4934 52 33C52 22.5066 43.4934 14 33 14C22.5066 14 14 22.5066 14 33C14 43.4934 22.5066 52 33 52Z",
    fill: "#F7B53C",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 39.6833C29.7472 40.6497 30.7717 41.3444 31.925 41.6667C34.4 42.3667 36.9875 41.0833 37.55 38.9833C38 36.65 36.0875 34.3167 33.5 33.7333C30.9125 33.0333 29 30.5833 29.5625 28.4833C30.125 26.2667 32.6 24.9833 35.1875 25.8C36.3125 26.0333 37.2125 26.7333 38 27.6667M33.6125 41.6667V44M33.6125 23V25.5667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008559);
export default __webpack_public_path__ + "static/media/Group 1000008559.ee6790e0227ae7fbdf9015e0ec1b454c.svg";
export { ForwardRef as ReactComponent };